module.exports = __webpack_public_path__ + "img/rclh-more.be3f3a2c.png";